import { render } from "./groupGoalDialog.vue?vue&type=template&id=44f3c50c&scoped=true"
import script from "./groupGoalDialog.vue?vue&type=script&lang=js"
export * from "./groupGoalDialog.vue?vue&type=script&lang=js"

import "./groupGoalDialog.vue?vue&type=style&index=0&id=44f3c50c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f3c50c"]])

export default __exports__